export function hexToRGBA(_color, _opacity = 1) {
  if (!_color)
    return ''
  let sColor = _color.toLowerCase()
  // 十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1)
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))

      sColor = sColorNew
    }
    // 处理六位的颜色值
    const sColorChange = []
    for (let i = 1; i < 7; i += 2)
      sColorChange.push(parseInt(`0x${sColor.slice(i, i + 2)}`))

    return `rgba(${sColorChange.join(',')},${_opacity})`
  }
  return sColor
}

/**
 * rgba转分解
 * @param {*} rgba 传入的rgba
 * @returns 各颜色值
 */
export function parseRGBA(rgba) {
  if (!rgba)
    return {}
  const rgbaRex = /rgba\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/i
  const [, r, g, b, a] = rgbaRex.exec(rgba)
  return {
    r,
    g,
    b,
    a,
  }
}